<template>
  <div
    v-if="prod"
    :id="'coffee-card-' + index"
    :class="{
      'funnel-coffee-card funnel-card-bottom-border hand-pointer mx-auto': true,
      picked: is_picked,
      'no-border': index === 2
    }"
    @click="emit('pick-coffee', prod)"
  >
    <div class="col-12 px-0 signup-card-no-bg-container d-flex justify-content-center align-items-end">
      <div class="signup-card-no-bg">
        <div class="row mx-0">
          <div class="col-6 col-md-4 pl-0 pr-2 signup-card-no-bg-imagery">
            <div class="signup-card-no-bg-top coffee-label-container">
              <SignupCoffeeRangeElementImage :product="prod" :imagecustomization="imagecustomization" />
              <div class="coffee-label-img" :style="[card_bg_img]" />
            </div>
            <div v-if="isMobileXsSm" class="d-flex justify-content-center" style="margin-top: 15px;">
              <!-- Price Section MobileXXS -->
              <div class="signup-card-no-bg-price t-center">
                <span v-if="lowest_amount_coffee_plan.discounted_price === null && !userData.is_pioneer" class="price-font">
                  <span class="variant-indicator">From</span>
                  £{{ parseFloat(lowest_amount_coffee_plan_price).toFixed(2) }}
                </span>
                <div v-else class="row mx-0">
                  <span class="col-12 px-0 price-font discounted">
                    <span class="variant-indicator">From</span>£{{ parseFloat(lowest_amount_coffee_discounted_price).toFixed(2) }}
                  </span>
                  <span class="col-12 px-0 pt-1 prod-old-price">was
                    (<span style="text-decoration-line: line-through;">£{{ parseFloat(lowest_amount_coffee_plan.price).toFixed(2) }} </span>)
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6 col-md-8 pl-2 pr-0 row mx-0 signup-card-no-bg-prod-details">
            <div class="col-12 px-0 signup-card-no-bg-prod-name-cnt">
              <div class="row mx-0">
                <div :class="{'col-12 pr-0': isMobileXsSm, 'col-6 col-sm-7 col-md-6 col-xl-7 pr-2 pr-md-1 pr-xl-2': !isMobileXsSm, 'pl-0': true }">
                  <div class="signup-card-no-bg-name d-flex align-items-start t-left">
                    <span class="two-line-clamp" :title="product_name"> {{ product_name }}</span>
                  </div>
                </div>
                <!-- Price Section Desktop -->
                <div v-if="!isMobileXsSm && !is_pods" class="col-6 col-sm-5 col-md-6 col-xl-5 pr-0 pl-1">
                  <div class="signup-card-no-bg-price t-right">
                    <span v-if="lowest_amount_coffee_plan.discounted_price === null && !userData.is_pioneer" class="price-font">
                      <span class="variant-indicator">From</span>
                      £{{ parseFloat(lowest_amount_coffee_plan_price).toFixed(2) }}
                    </span>
                    <div v-else class="row mx-0">
                      <span class="col-12 px-0 price-font discounted">
                        <span class="variant-indicator">From</span>£{{ parseFloat(lowest_amount_coffee_discounted_price).toFixed(2) }}
                      </span>
                      <span class="col-12 px-0 pt-1 prod-old-price">was
                        (<span style="text-decoration-line: line-through;">£{{ parseFloat(lowest_amount_coffee_plan.price).toFixed(2) }} </span>)
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Roast and Hints text Coffees -->
            <div class="col-12 px-0">
              <div class="signup-card-no-bg-info">
                <div class="signup-card-no-bg-taste-and-roast three-line-clamp align-items-center justify-content-start">
                  <span v-if="prod.roast_profile">
                    {{ prod.roast_profile }} roast with
                  </span>
                  <span v-if="prod.hints_of">
                    hints of {{ prod.hints_of }}
                  </span>
                </div>
              </div>
            </div>
            <!-- Available Variants Indicator and Product Origin -->
            <div class="col-12 px-0 t-left">
              <div class="row mx-0">
                <!-- Available Variants -->
                <div class="col-12 px-0">
                  <div
                    class="signup-card-no-bg-variants"
                  >
                    <div class="d-flex flex-wrap">
                      <span v-for="(amount, index) in coffee_plans_amounts" :key="index">
                        <span>{{ amount.toLowerCase() }}</span>
                      </span>
                    </div>
                  </div>
                </div>
                <!-- Product Origin -->
                <div class="col-12 pl-0">
                  <div class="signup-card-no-bg-origin d-flex align-items-center">
                    <img
                      :src="prod.origin.includes('Blend') || prod.origin_flag === null ? 'https://res.cloudinary.com/pactcoffee/image/upload/v1651654229/website-d2c/assets/uploadedCMS/2022/Navigation/navbar-icons/earth.svg' : prod.origin_flag"
                      :class="{
                        'signup-card-no-bg-origin-flag': true,
                        'blend-height': prod.origin.includes('Blend') || prod.origin_flag === null ,
                      }"
                      width="30"
                      height="22"
                      alt="origin flag icon"
                    >
                    <span class="one-line-clamp">{{ prod.origin }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { inject, computed, toRefs, defineAsyncComponent } from 'vue'
import { useCloudinaryHelpers } from '../../utils/composables/cloudinaryHelpers'
import { useMobileHelpers } from '../../utils/composables/mobileHelpers'

const SignupCoffeeRangeElementImage = defineAsyncComponent(() => import('../../SignupA/elements/SignupCoffeeRangeElementImage.vue'))

// Props (defineProps)
const props = defineProps({
	product: {
		type: Object,
		required: true,
	},
	index: {
		type: Number,
		required: true,
	},
	is_picked: {
		type: Boolean,
		required: false,
    default: false
	},
})
// Emits (defineEmits)
// Reactive variables (inc composables)
const userData = inject('userData')
const hide_500g_plans = inject('hide_500g_plans')
const { product, index, is_pods } = toRefs(props)
const emit = defineEmits(['pick-coffee'])
const { optimizeImage } = useCloudinaryHelpers()
// Emits (defineEmits)
// Reactive variables (inc composables)
const { isMobileXsSm } = useMobileHelpers()
// Computed
const prod = computed(() => {
  return product.value
})
const has_label_artwork = computed(() => {
  return (
    prod.value &&
    prod.value.label_artwork &&
    prod.value.label_artwork !== null
  )
})
const label_artwork_img = computed(() => {
  return `background-image: url(${optimizeImage(prod.value.label_artwork)})`
})
const card_bg_img = computed(() => {
  return has_label_artwork.value ? label_artwork_img.value : 'background-color: #f5f5f5'
})
const coffee_plans = computed(() => {
  var plans = {}
  prod.value.coffee_plans.forEach((plan) => {
    plans = {
      ...plans,
      ...plan
    }
  })
  return plans
})
const coffee_plans_amounts = computed(() => {
  var plans = []
  var amounts = { 250: '250g', 500: '500g', 1000: '1kg' }
  var amounts_to_show = []
  if(hide_500g_plans?.value) plans = sortPlanByAmount(Object.values(coffee_plans.value)).filter((plan) => plan.amount !== 500)
  else plans = sortPlanByAmount(Object.values(coffee_plans.value))

  plans.map((plan) => {
    amounts_to_show.push(amounts[plan.amount])
  })

  return amounts_to_show
})
const lowest_amount_coffee_plan = computed(() => {
  return coffee_plans.value['250g']
})
const lowest_amount_coffee_plan_price = computed(() => {
  return userData.value.is_pioneer ? lowest_amount_coffee_plan.value.pioneer_price : lowest_amount_coffee_plan.value.price
})
const lowest_amount_coffee_discounted_price = computed(() => {
  if( userData.value.is_pioneer && lowest_amount_coffee_plan.value.discounted_price !== null ){
    return lowest_amount_coffee_plan.value.pioneer_discounted_price
  } else return userData.value.is_pioneer ? lowest_amount_coffee_plan.value.pioneer_price : lowest_amount_coffee_plan.value.discounted_price
})
const product_name = computed(() => {
  return prod.value.name
})
// Methods
function sortPlanByAmount(plans){
  return plans.sort((a,b) => {
    if (a.amount < b.amount) {
      return -1
    } else if (a.amount > b.amount) {
      return 1
    }
    return 0
  })
}

// Watchers
// Lifecycle Hooks
// Expose (defineExpose)
</script>

<style lang="scss" scoped>
.funnel-coffee-card {
  position: relative;

	&.picked {
    &::before{
      content: '';
      width: calc(100% + 30px);
      background-color: #EAF9F6;
      border: 3px solid #30BEA6;
      border-radius: 8px;
      position: absolute;
      top: -15px;
      left: -15px;
      z-index: -1;
      height: 100%;
    }
	}

  .signup-card-no-bg {
    width: 100%;
    height: fit-content;

    &-top {
      position: relative;
      height: 94px;
      margin-bottom: 0px;
      @media (min-width: 992px) {
        height: 150px;
        margin-bottom: 0px;
      }

      &.coffee-label-container {
        margin-bottom: 0px;

        @media (max-width: 399px) {
          height: 150px;
        }

        @media (min-width: 400px) and (max-width: 575px) {
          height: 196px;
        }

        @media (min-width: 576px) and (max-width: 767px){
          height: 160px;
        }

        @media (min-width: 768px) and (max-width: 991px){
          height: 205px;
        }

        @media (min-width: 992px) and (max-width: 1499px){
          @media (max-height: 700px){
            height: 170px;
          }
          height: 190px;
        }

        @media (min-width: 1500px){
          height: 224px;
        }

        .coffee-label-img {
          background-position: center;
          background-repeat: no-repeat;
          background-size: cover;
          margin-bottom: 0px;
          height: 100px;
          width: 100%;
          position: absolute;
          bottom: 0px;
          z-index: -1;

          @media (min-width: 576px) and (max-width: 767px){
            height: 90px;
          }

          @media (min-width: 768px) and (max-width: 991px){
            height: 138px;
          }

          @media (min-width: 992px) and (max-width: 1499px) {
            @media (max-height: 700px){
              height: 100px;
            }
            height: 110px;
          }

          @media (min-width: 1500px) {
            height: 120px;
          }
        }
      }
    }

    &-prod-details{
      @media (min-width: 576px){
        margin-top: 15px;
      }
    }

    .signup-card-no-bg-prod-name-cnt{
      margin-bottom: 15px;

      &.equip-mob{
        @media (max-width: 575px){
          margin-bottom: 0px !important;
        }
      }
    }

    &-name {
      height: 48px;

      span {
        color: #212427;
        leading-trim: both;
        font-family: "Apercu";
        font-size: 18px;
        font-style: normal;
        font-weight: 700;
        line-height: 24px; /* 122.222% */
        letter-spacing: 0px;
      }
    }

    &-taste-and-roast {
      text-align: left;
      margin-bottom: 15px;

      @media (min-width: 767px) {
        height: 54px;
      }

      span {
        font-family: 'Apercu';
        font-style: normal;
        font-weight: 300;
        font-size: 14px;
        line-height: 18px;
        color: #212427;
      }

    }

    &-price {
      .price-font {
        font-style: normal;
        font-size: 20px;
        line-height: 20px;
        font-weight: 700;
        color: #212427;
        letter-spacing: 0px;

        &.discounted {
          color: #D94822;
        }

        .variant-indicator {
          color: #212427;
          font-family: Apercu;
          font-size: 14px;
          font-style: normal;
          font-weight: 300;
          line-height: 16px;
          letter-spacing: 0px;
          padding-right: 5px;
          position: relative;
          top: -5px;
        }
      }

      .prod-old-price{
        color: #212427 !important;
        font-family: 'Apercu';
        font-size: 14px;
        font-style: normal;
        font-weight: 300 !important;
        line-height: 16px;
        letter-spacing: 0px;
      }
    }

    &-origin {
      display: flex;
      align-items: normal;
      @media (min-width: 576px) {
        align-items: center;
      }
      &-flag {
        height: 20px;
        width: 27px;
        margin-right: 10px;
      }
      .blend-height{
        width: 15px !important;
        @media (min-width: 992px) {
          width: 22px !important;
        }
      }
      span {
        font-family: 'Apercu';
        font-style: normal;
        font-weight: 300;
        color: #212427;
        font-size: 14px;
        line-height: 14px;
        margin-top: 2px;
      }
    }


    &-variants {
      margin-bottom: 15px;

        span {
          color: #212427;
          text-align: left;
          font-family: 'Apercu';
          font-size: 14px;
          font-style: normal;
          font-weight: 700;
          line-height: 20px;
          letter-spacing: 0px;

          &:before{
            content: '/';
            font-size: 14px;
            font-style: normal;
            font-weight: 300;
            line-height: 20px;
            padding: 0 5px;
            letter-spacing: 0px;
          }

          &:first-child{
            &:before{
              content: '';
              padding: 0;
            }
          }
        }
      }
    }
  }

	.funnel-card-bottom-border {
			border-bottom: 1px solid #F4F4F4;
			margin-top: 30px;
			padding-bottom: 30px;

    &.mt-0 {
      @media (max-width: 767px) { margin-top: 0px; }
    }

    &.no-border{
      border: none;
    }
	}
</style>